<template #content>
    <Dialog :visible="visible" @update:visible="updateVisible" :header="'Perfil: ' + perfil.descricao" @show="onShow"
        @hide="onHide" class="w-11 lg:w-4" modal>
        <form @submit.prevent="onSubmit(permissaoSelectedKey)">
            <Tabs class="contrato-tab-principal" :value="tabIndex">
                <TabList>
                    <Tab :value="0">Permissões</Tab>
                    <Tab :value="1">Etapas</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel :value="0">
                        <div class="w-full">
                            <Tree :filter="true" v-model:selectionKeys="permissaoSelectedKey" :loading="isLoading" :value="permissaoTreeData"
                                selectionMode="checkbox" scrollHeight="calc(50vh)" class="w-full"
                                :expandedKeys="permissaoExpandedKeys"></Tree>
                        </div>
                    </TabPanel>
                    <TabPanel :value="1">
                        <div class="w-full">
                            <Tree :filter="true" v-model:selectionKeys="etapaSelectedKey" :loading="isLoading" :value="etapaTreeData"
                                selectionMode="checkbox" scrollHeight="calc(50vh)" class="w-full"
                                :expandedKeys="etapaExpandedKeys"></Tree>
                        </div>
                    </TabPanel>
                </TabPanels>
            </Tabs>
            

            <div class="flex justify-content-end gap-1">
                <Button type="submit" label="Salvar" severity="success" icon="pi pi-save" size="small"
                    class="flex align-items-center justify-content-center" :loading="isLoading" />
                <Button label="Fechar" severity="warn" icon="pi pi-times" size="small" @click="updateVisible(false)"
                    class="flex align-items-center justify-content-center" :loading="isLoading" />
            </div>
        </form>

    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Checkbox from 'primevue/checkbox';
import Button from 'primevue/button';
import Tree from 'primevue/tree';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import Perfil from '@/service/perfil.js';

export default {
    components: { Dialog, 
                  FloatLabel, 
                  Button, 
                  InputText, 
                  Checkbox, 
                  Tree,
                  Tabs, 
                  TabList, 
                  Tab, 
                  TabPanels, 
                  TabPanel, },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        perfil: {
            type: Object,
            default: {}
        },
    },
    emits: ['save', 'close'],
    data() {
        return {
            permissaoSelectedKey: [],
            permissaoExpandedKeys: {},
            permissaoTreeData: [],
            etapaSelectedKey: [],
            etapaExpandedKeys: {},
            etapaTreeData: [],
            isLoading: false,
            tabIndex: 0,
        }
    },
    methods: {
        onShow() {
            this.isLoading = true;
            Perfil.permissoes(this.perfil.id)
                .then(response => {
                    let permissoes = response.data,
                        permissaoTreeData = [],
                        permissaoExpandedKeys = {},
                        permissaoSelectedKey = {};

                    permissaoExpandedKeys['todos'] = true;

                    permissoes.forEach(item => {
                        item.checked = JSON.parse(item.checked);
                        permissaoSelectedKey[item.key] = item.checked;
                        if (item.children) {
                            permissaoExpandedKeys[item.key] = true;
                            item.children.forEach(subItem => {
                                subItem.checked = JSON.parse(subItem.checked);
                                permissaoSelectedKey[subItem.key] = subItem.checked;
                            });
                        }
                    });

                    const todosChecked      = permissoes.every(item => item.checked?.checked);
                    const qualquerChecked   = permissoes.some(item => item.checked?.checked || item.checked?.partialChecked);

                    permissaoSelectedKey['todos'] = {
                        checked: todosChecked,
                        partialChecked: !todosChecked && qualquerChecked
                    };

                    permissaoTreeData.push({
                        key: 'todos',
                        label: 'Selecionar Todos',
                        children: permissoes,
                    });

                    this.permissaoTreeData = permissaoTreeData;
                    this.permissaoSelectedKey = permissaoSelectedKey;
                    this.permissaoExpandedKeys = permissaoExpandedKeys;
                })
                .finally(() => {
                    this.isLoading = false;
                });

            Perfil.etapas(this.perfil.id)
                .then(response => {
                    let etapas = response.data,
                        etapaTreeData = [],
                        etapaExpandedKeys = {},
                        etapaSelectedKey = {};

                    etapaExpandedKeys['todos'] = true;

                    etapas.forEach(item => {
                        item.checked = JSON.parse(item.checked);
                        etapaSelectedKey[item.key] = item.checked;
                        if (item.children) {
                            etapaExpandedKeys[item.key] = true;
                            item.children.forEach(subItem => {
                                subItem.checked = JSON.parse(subItem.checked);
                                etapaSelectedKey[subItem.key] = subItem.checked;
                            });
                        }
                    });

                    const todosChecked      = etapas.every(item => item.checked?.checked);
                    const qualquerChecked   = etapas.some(item => item.checked?.checked || item.checked?.partialChecked);

                    etapaSelectedKey['todos'] = {
                        checked: todosChecked,
                        partialChecked: !todosChecked && qualquerChecked
                    };

                    etapaTreeData.push({
                        key: 'todos',
                        label: 'Selecionar Todos',
                        children: etapas,
                    });

                    this.etapaTreeData = etapaTreeData;
                    this.etapaSelectedKey = etapaSelectedKey;
                    this.etapaExpandedKeys = etapaExpandedKeys;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        onHide() {
            this.permissaoSelectedKey = [];
            this.permissaoTreeData = [];

            this.etapaSelectedKey = [];
            this.etapaTreeData = [];
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },

        getSelectedKeyData(selectedKey) {
            let dados = [];
            for (let i in selectedKey) {
                let node = { id: i, checked: 0 };
                if (node.id != 'todos') {
                    if (selectedKey[i] && selectedKey[i].checked) {
                        node.checked = 1;
                        dados.push(node);
                    } else if (selectedKey[i] && selectedKey[i].partialChecked) {
                        node.checked = 2;
                        dados.push(node);
                    }
                }
            }
            return dados;
        },

        onSubmit() {
            const dados = { permissoes: this.getSelectedKeyData(this.permissaoSelectedKey), 
                            etapas: this.getSelectedKeyData(this.etapaSelectedKey) };

            this.isLoading = true;
            Perfil.configuracao(this.perfil.id, dados)
                .then(response => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Seus dados foram salvos com sucesso.', life: 3000 });
                    this.$emit('save');
                    this.$emit('close');
                })
                .catch(error => {
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
}
</script>
